import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../../Asset/img/bluspace-w.png';
const Navbar = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  return (
    <NavWrapper>
      <LogoWrapper
        onClick={() => {
          navigate('/');
        }}>
        <img src={logo} alt="our-logo" />
      </LogoWrapper>
      <NavItemWrapper>
        <NavItems className={isMobile ? 'res-nav' : 'none'}>
          <NavLink
            onClick={() => {
              navigate('/');
              setIsMobile(false)
            }}>
            Home
          </NavLink>
          <NavLink
            onClick={() => {
              navigate('/about-us');
              setIsMobile(false)
            }}>
            About
          </NavLink>
          <NavLink
            onClick={() => {
              navigate('/services');
              setIsMobile(false)
            }}>
            Services
          </NavLink>
          <NavLink
            onClick={() => {
              navigate('/blog');
              setIsMobile(false)
            }}>
            Blog
          </NavLink>
          <NavLink
            onClick={() => {
              navigate('/contact');
              setIsMobile(false)
            }}>
            Contact
          </NavLink>
        </NavItems>
      </NavItemWrapper>
        <Burger onClick={() => {setIsMobile(!isMobile)}}>
         {isMobile ?  <FaTimes className='bar'/> : <FaBars className='bar' />  }
        </Burger>
      
    </NavWrapper>
  );
};
const NavWrapper = styled.nav`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  height: 10vh;
  background: linear-gradient(-192deg, var(--bg-color), var(--text-color));
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  @media screen and (max-width: 430px) {
    padding: 8px;
  }
`;

const LogoWrapper = styled.div`
  cursor: pointer;
  width: 20%;
  img {
    width: 45%;
  }
  @media screen and (max-width: 884px) {
    width: 60%;
    img{
      width: 55%;
    }
  }
  @media screen and (max-width: 768px) {
    width: 70%;
    img{
      width: 55%;
    }
  }
  @media screen and (max-width: 430px) {
    width: 60%;
    img{
      width: 65%;
    }
  }
`;

const NavItemWrapper = styled.div`
`;

const NavItems = styled.ul`
  /* display: flex; */
  align-items: center;
`;

const NavLink = styled.li`
  padding: 0 20px;
  color: var(--main-color);
  cursor: pointer;
  font-size: 1.05rem;
  font-weight: 600;

  @media screen and (max-width: 768px) {
    padding: 0 10px;
  }

  @media screen and (max-width: 430px) {
    background: linear-gradient(102deg, var(--bg-color), var(--text-color));
    border-radius: .2rem;
    box-shadow: 0 .5rem 1rem var(--bga-color);
    font-size: 1.4rem;
    font-weight: 700;
    text-align: center;
    width: 98%;
    padding: 20px 10px;
    margin: 8px 0;
    transition: all 2s ease-in-out;
  }
  @media screen and (max-width: 360px) {
   margin: 5px 0;
   }
`;

const Burger = styled.div`
  padding-right: 12px;
  cursor: pointer;
  display: none;
  .bar{
    color: var(--main-color);
    font-size: 25px;
  }

  @media screen and (max-width: 430px) {
    display: flex;
  }
`
export default Navbar;
